import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useSelector, useDispatch } from 'react-redux';

import { history } from '../../../_services/essentials/helpers';
import {masterProfilesActions, alertActions, breadcrumbsActions} from '../../../_services/essentials/store';

export { AddEdit };

function AddEdit() {

    const entities = 'master_profiles';
    const entityLabel = 'Profile';
    const { id } = useParams();
    const dispatch = useDispatch();
    const entity = useSelector(x => x.master_profiles?.item);
    // form validation rules
    const validationSchema = Yup.object().shape({
        organizationName: Yup.string()
            .required('Organization Name is required'),
        websiteURL: Yup.string()
            .required('websiteURL URL is required'),

    });
    const formOptions = { resolver: yupResolver(validationSchema) };

    // get functions to build form with useForm() hook
    const { register, handleSubmit, reset, formState } = useForm(formOptions);
    const { errors, isSubmitting } = formState;

    dispatch(breadcrumbsActions.setCurrentURL({
        url: history.location?.pathname,
        state: history.location?.state
    }));

    useEffect(() => {
        dispatch(breadcrumbsActions.setCurrentTitle(`Profiles`));
        if (id) {
            // fetch user details into redux state and
            // populate form fields with reset()
            dispatch(masterProfilesActions.getById(id)).unwrap()
                .then(entity => {
                    reset(entity);
                });
        } else {
            const newEntity = {
                organizationName: "",
                websiteURL: ""
            };
            reset(newEntity);
        }
    }, [id, dispatch, reset, entityLabel]);

    useEffect(() => {
        //dispatch(customersActions.getAllStatuses());
    }, [dispatch]);


    async function onSubmit(data) {
        dispatch(alertActions.clear());
        //alert('Updated Data: '+JSON.stringify(data));
        try {
            // create or update user based on id param
            let message;
            if (id) {
                await dispatch(masterProfilesActions.update({ id, data })).unwrap();
                //TODO: Make use of return value. and display message based on return value
                message = `${entityLabel} updated`;
            } else {
                const response = await dispatch(masterProfilesActions.create({data})).unwrap();
                dispatch(alertActions.error(response));
                //TODO: Make use of return value. and display message based on return value
                message = response;
                //message = 'User added';
            }

            // redirect to user list with success message
            history.navigate(`/${entities}`);
            dispatch(alertActions.success({ message, showAfterRedirect: true }));
        } catch (error) {
            dispatch(alertActions.error(error));
        }
    }

    return (
        <div>
            {!(entity?.loading || entity?.error) &&
                <form onSubmit={handleSubmit(onSubmit)}>
                    {/* Start: View and Edit section */}
                    <div className="row">
                        <div className="mb-3 col">
                            <label className="form-label">Id</label>
                            <input name="id" type="text" {...register('id', {required: true})} className={`form-control ${errors.id ? 'is-invalid' : ''}`} />
                            <div className="invalid-feedback">{errors.id?.message}</div>
                        </div>
                        <div className="mb-3 col">
                            <label className="form-label">KOL Id</label>
                            <input name="kolId" type="text" {...register('kolId', {required: true}) } className={`form-control ${errors.kolId ? 'is-invalid' : ''}`} />
                            <div className="invalid-feedback">{errors.kolId?.message}</div>
                        </div>
                        <div className="mb-3 col">
                            <label className="form-label">Status</label>
                            <input name="status" type="text" {...register('status', {required: true}) } className={`form-control ${errors.status ? 'is-invalid' : ''}`} />
                            <div className="invalid-feedback">{errors.status?.message}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="mb-3 col">
                            <label className="form-label">KOL Name</label>
                            <input name="kolName" type="text" {...register('kolName', {required: true})} className={`form-control ${errors.kolName ? 'is-invalid' : ''}`} />
                            <div className="invalid-feedback">{errors.kolName?.message}</div>
                        </div>
                        <div className="mb-3 col">
                            <label className="form-label">Firstname</label>
                            <input name="firstname" type="text" {...register('firstname', {required: true}) } className={`form-control ${errors.firstname ? 'is-invalid' : ''}`} />
                            <div className="invalid-feedback">{errors.firstname?.message}</div>
                        </div>
                        <div className="mb-3 col">
                            <label className="form-label">Middlename</label>
                            <input name="middlename" type="text" {...register('middlename', {required: true}) } className={`form-control ${errors.middlename ? 'is-invalid' : ''}`} />
                            <div className="invalid-feedback">{errors.middlename?.message}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="mb-3 col">
                            <label className="form-label">Lastname</label>
                            <input name="lastname" type="text" {...register('lastname', {required: true})} className={`form-control ${errors.lastname ? 'is-invalid' : ''}`} />
                            <div className="invalid-feedback">{errors.lastname?.message}</div>
                        </div>
                        <div className="mb-3 col">
                            <label className="form-label">PMID</label>
                            <input name="pmid" type="text" {...register('pmid', {required: true}) } className={`form-control ${errors.pmid ? 'is-invalid' : ''}`} />
                            <div className="invalid-feedback">{errors.pmid?.message}</div>
                        </div>
                        <div className="mb-3 col">
                            <label className="form-label">NCTID</label>
                            <input name="nctid" type="text" {...register('nctid', {required: true}) } className={`form-control ${errors.nctid ? 'is-invalid' : ''}`} />
                            <div className="invalid-feedback">{errors.nctid?.message}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="mb-3 col">
                            <label className="form-label">NPI</label>
                            <input name="npi" type="text" {...register('npi', {required: true})} className={`form-control ${errors.npi ? 'is-invalid' : ''}`} />
                            <div className="invalid-feedback">{errors.npi?.message}</div>
                        </div>
                        <div className="mb-3 col">
                            <label className="form-label">NPI URL</label>
                            <input name="npiURL" type="text" {...register('npiURL', {required: true}) } className={`form-control ${errors.npiURL ? 'is-invalid' : ''}`} />
                            <div className="invalid-feedback">{errors.npiURL?.message}</div>
                        </div>
                        <div className="mb-3 col">
                            <label className="form-label">Sunshine</label>
                            <input name="sunshine" type="text" {...register('sunshine', {required: true}) } className={`form-control ${errors.sunshine ? 'is-invalid' : ''}`} />
                            <div className="invalid-feedback">{errors.sunshine?.message}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="mb-3 col">
                            <label className="form-label">Sunshine URL</label>
                            <input name="sunshineURL" type="text" {...register('sunshineURL', {required: true})} className={`form-control ${errors.sunshineURL ? 'is-invalid' : ''}`} />
                            <div className="invalid-feedback">{errors.sunshineURL?.message}</div>
                        </div>
                        <div className="mb-3 col">
                            <label className="form-label">Therapeutic Area</label>
                            <input name="therapeuticArea" type="text" {...register('therapeuticArea', {required: true}) } className={`form-control ${errors.therapeuticArea ? 'is-invalid' : ''}`} />
                            <div className="invalid-feedback">{errors.therapeuticArea?.message}</div>
                        </div>
                        <div className="mb-3 col">
                            <label className="form-label">Specialty</label>
                            <input name="specialty" type="text" {...register('specialty', {required: true}) } className={`form-control ${errors.specialty ? 'is-invalid' : ''}`} />
                            <div className="invalid-feedback">{errors.specialty?.message}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="mb-3 col">
                            <label className="form-label">Salutation</label>
                            <input name="salutation" type="text" {...register('salutation', {required: true})} className={`form-control ${errors.salutation ? 'is-invalid' : ''}`} />
                            <div className="invalid-feedback">{errors.salutation?.message}</div>
                        </div>
                        <div className="mb-3 col">
                            <label className="form-label">Affiliation</label>
                            <input name="affiliation" type="text" {...register('affiliation', {required: true}) } className={`form-control ${errors.affiliation ? 'is-invalid' : ''}`} />
                            <div className="invalid-feedback">{errors.affiliation?.message}</div>
                        </div>
                        <div className="mb-3 col">
                            <label className="form-label">ParentOrganization</label>
                            <input name="parentOrganization" type="text" {...register('parentOrganization', {required: true}) } className={`form-control ${errors.parentOrganization ? 'is-invalid' : ''}`} />
                            <div className="invalid-feedback">{errors.parentOrganization?.message}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="mb-3 col">
                            <label className="form-label">Department</label>
                            <input name="department" type="text" {...register('department', {required: true})} className={`form-control ${errors.department ? 'is-invalid' : ''}`} />
                            <div className="invalid-feedback">{errors.department?.message}</div>
                        </div>
                        <div className="mb-3 col">
                            <label className="form-label">Designation</label>
                            <input name="designation" type="text" {...register('designation', {required: true}) } className={`form-control ${errors.designation ? 'is-invalid' : ''}`} />
                            <div className="invalid-feedback">{errors.designation?.message}</div>
                        </div>
                        <div className="mb-3 col">
                            <label className="form-label">Address</label>
                            <input name="address" type="text" {...register('address', {required: true}) } className={`form-control ${errors.address ? 'is-invalid' : ''}`} />
                            <div className="invalid-feedback">{errors.address?.message}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="mb-3 col">
                            <label className="form-label">Zip code</label>
                            <input name="zipcode" type="text" {...register('zipcode', {required: true})} className={`form-control ${errors.zipcode ? 'is-invalid' : ''}`} />
                            <div className="invalid-feedback">{errors.zipcode?.message}</div>
                        </div>
                        <div className="mb-3 col">
                            <label className="form-label">City</label>
                            <input name="city" type="text" {...register('city', {required: true}) } className={`form-control ${errors.city ? 'is-invalid' : ''}`} />
                            <div className="invalid-feedback">{errors.city?.message}</div>
                        </div>
                        <div className="mb-3 col">
                            <label className="form-label">State</label>
                            <input name="state" type="text" {...register('state', {required: true}) } className={`form-control ${errors.state ? 'is-invalid' : ''}`} />
                            <div className="invalid-feedback">{errors.state?.message}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="mb-3 col">
                            <label className="form-label">Phone</label>
                            <input name="phone" type="text" {...register('phone', {required: true})} className={`form-control ${errors.phone ? 'is-invalid' : ''}`} />
                            <div className="invalid-feedback">{errors.phone?.message}</div>
                        </div>
                        <div className="mb-3 col">
                            <label className="form-label">Fax</label>
                            <input name="fax" type="text" {...register('fax', {required: true}) } className={`form-control ${errors.fax ? 'is-invalid' : ''}`} />
                            <div className="invalid-feedback">{errors.fax?.message}</div>
                        </div>
                        <div className="mb-3 col">
                            <label className="form-label">Email</label>
                            <input name="email" type="text" {...register('email', {required: true}) } className={`form-control ${errors.email ? 'is-invalid' : ''}`} />
                            <div className="invalid-feedback">{errors.email?.message}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="mb-3 col">
                            <label className="form-label">Country</label>
                            <input name="country" type="text" {...register('country', {required: true})} className={`form-control ${errors.country ? 'is-invalid' : ''}`} />
                            <div className="invalid-feedback">{errors.country?.message}</div>
                        </div>
                        <div className="mb-3 col">
                            <label className="form-label">Suffix</label>
                            <input name="suffix" type="text" {...register('suffix', {required: true}) } className={`form-control ${errors.suffix ? 'is-invalid' : ''}`} />
                            <div className="invalid-feedback">{errors.suffix?.message}</div>
                        </div>
                        <div className="mb-3 col">
                            <label className="form-label">Bio Summary</label>
                            <input name="bioSummary" type="text" {...register('bioSummary', {required: true}) } className={`form-control ${errors.bioSummary ? 'is-invalid' : ''}`} />
                            <div className="invalid-feedback">{errors.bioSummary?.message}</div>
                        </div>
                    </div>

                    {/* End: View and Edit section*/}
                    <div className="mb-3">
                        <button type="submit" disabled={isSubmitting} className="btn btn-primary me-2">
                            {isSubmitting && <span className="spinner-border spinner-border-sm me-1"></span>}
                            Save
                        </button>
                        <button onClick={() => reset()} type="button" disabled={isSubmitting} className="btn btn-secondary">Reset</button>
                        <Link to={`/${entities}`} className="btn btn-link">Cancel</Link>
                    </div>
                </form>
            }
            {entity?.loading &&
                <div className="text-center m-5">
                    <span className="spinner-border spinner-border-lg align-center"></span>
                </div>
            }
            {entity?.error &&
                <div class="text-center m-5">
                    <div class="text-danger">Error loading user: {entity.error}</div>
                </div>
            }
        </div>
    );
}
